import { useCallback, useEffect } from 'react';
import { atom, useAtom } from 'jotai';
import { useMapViewStateUpdater } from './useMapViewState';
import { useAggregationConfig } from './useAggregationConfig';

type UseThreeDMode = {
  isThreeDMode: boolean;
  setThreeDMode: (enabled: boolean) => void;
};

const isThreeDModeAtom = atom<boolean>(false);

const useThreeDMode = (): UseThreeDMode => {
  const [isThreeDMode, setIsThreeDMode] = useAtom(isThreeDModeAtom);
  const { aggregationConfig } = useAggregationConfig();
  const { updateMapViewState } = useMapViewStateUpdater();

  const setThreeDMode = useCallback(
    (enabled: boolean) => {
      // 3Dモードのオン・オフに合わせて地図の傾きを変更する
      setIsThreeDMode(enabled);
      updateMapViewState({ pitch: enabled ? 45 : 0 });
    },
    [setIsThreeDMode, updateMapViewState]
  );

  useEffect((): void => {
    // グリッドヒートマップ以外のレイヤーが選択された場合、3Dモードをオフにする
    if (aggregationConfig?.type !== 'grid_heatmap' && isThreeDMode) {
      setThreeDMode(false);
    }
  }, [aggregationConfig?.type, isThreeDMode, setThreeDMode]);

  return {
    isThreeDMode,
    setThreeDMode,
  };
};

export { useThreeDMode };
